import React from "react";
import { SVGIconProps } from "./SVGIconProps";
function Download(props: SVGIconProps) {
    const { width = 16, height = 16, fillColor = "#7A869A", onClick } = props;
    return (
        <svg width={width}
            height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <path d="M8 9V2" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.5 9V13H2.5V9" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.5 6.5L8 9L5.5 6.5" stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
}
export default Download;